import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import './pageHeader.css'
import useHandleRequest from "../../custom_hooks/useHandleRequest";

function PageHeader({navigationLinks = [], currentPage = '', mainTitle= ''}) {

    const {handleRequestAndNavigate} = useHandleRequest();

    const handlePageChange = (e, newPage) => {
        const editedPage = newPage.slice(1)
        if(editedPage === ""){
            handleRequestAndNavigate(e, newPage, `${editedPage}/`, `home`)
        }else {
            handleRequestAndNavigate(e, newPage, `${editedPage}/`, `${editedPage}`)

        }
    }

    return (
        <>
            <Container className={'page-header-wrapper'}>
                <Row>
                    <Col className={'d-flex justify-content-center'}>
                        <h1>{mainTitle}
                        </h1>
                    </Col>
                </Row>
                <Row className={'mt-3'}>
                    <Col className={'d-flex flex-wrap justify-content-center align-items-center'}>
                        {navigationLinks.map((link,index) =>

                            (
                                <React.Fragment key={index}>
                                    {console.log(link.href)}
                                    <Link to={link.href} onClick={(e)=>handlePageChange(e,link.href)}>{link.title}</Link>
                                    <span>&nbsp;&nbsp; / &nbsp;&nbsp;</span>
                                </React.Fragment>
                            )

                        )}
                        <p className={'active-link'}> {currentPage} </p>
                    </Col>
                </Row>
            </Container>
            <Container className={'svg-container'} fluid>
                <Row>
                    <Col className={'svg-col'}>
                        <svg viewBox="0 0 500 120" preserveAspectRatio="none" style={{height: "100%", width: "100%"}}>
                            <path
                                d="M-158.29,-100 C14.39,200 423.53,-120 553.89,100"
                                style={{
                                    stroke: "#01a479",
                                    fill: "none",
                                    strokeWidth: "0.5"
                                }}>
                            </path>
                        </svg>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default PageHeader;